var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-content"},[_c('Temporary'),_vm._v(" "),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticStyle:{"padding-left":"24px"}},[_c('li',[_vm._v("\n\t\t\t\t\tใช้ใน Lot ไหน เท่าไหร่\n\t\t\t")]),_vm._v(" "),_c('li',[_vm._v("\n\t\t\t\t\tข้อมูลต้อง merge กันเยอะ เลยรอก่อน\n\t\t\t")])])])
}]

export { render, staticRenderFns }